<script setup>

const commercialStore = useCommercialStore()

commercialStore.seo_mode = true
const app_config = useAppConfig()
const { params } = useRoute()
const { offertype, type } = params

const page_title = ref('-')
const page_header = ref('-')
const query = {}

if( offertype && app_config[offertype] ){
    let data_offertype = app_config[offertype]
    let data_type = data_offertype.types.find( e => e.slug == type )
    let header = capitalize( `${data_offertype.header} ${data_type.vin} ${app_config.city.rod}` )
    page_header.value = header
    page_title.value = header
    query.offertype = offertype
    query.type = type
    query.metros = ''
    query.raions = ''
    query.page = 1
    query.area_ot = ''
    query.area_do = ''
    query.price_ot = ''
    query.price_do = ''
    query.mode = null
}

useSeoMeta({
    title: page_title.value,
})

const raionsStore = useRaionsStore()
const raions_list = ref([])
await raionsStore.getList()

;(async () => {
    let res = []
    const count = parseInt(raionsStore.items.length / 4)
    for (var i = 0; i < count; i++) {
        res.push(raionsStore.items.slice(i * 4, i * 4 + 4))
    }
    if (count * 4 < raionsStore.items.length) {
        res.push(raionsStore.items.slice(count * 4))
    }
    raions_list.value = res
})()

const objBreadcrumb = {
    offerType: app_config[offertype],
    data_type: app_config[offertype].types.find( e => e.slug == type ),
}

</script>
<template>
    
    <LayoutsCatalog :header="page_header" :seo_mode="true" :objBreadcrumb="objBreadcrumb" >
        <template #filter>
            <Filter :query="query" :autorun="true" />
        </template>
        <template #end>
            <div class="container mb-6">
                    
                <LayoutsVstroenniyPomeshenia 
                    :offertype="offertype" 
                    v-if="type == 'vstroenniy-pomeshenia'" 
                    class="mt-5" 
                />

                <div v-show="type == 'vstroenniy-pomeshenia'"  class="md:block hidden mt-8 cursor-pointer md:hover:scale-[1.06] z-[6] md:hover:z-10 transition-transform">
                    <img class="rounded-xl" src="/img/banner/banner_comercial.jpg" alt="banner">
                </div>
            </div>

            <section data-raions class="result bg-brand-bright md:pb-1 md:pt-4 pt-0">
                <div class="container">
                    <div class="near bg-white mt-3 p-3 md:pb-6 md:pt-6 md:bg-transparent md:border-0 border border-custom-gray rounded-lg">
                        <h3 class="pb-3 md:text-base text-xl text-brand-grey">{{ page_header }} в вашем <span>районе</span></h3>
                        <div class="grid-cols-5 items-start pb-3  hidden md:grid gap-y-2">
                            <template v-for="raions in raions_list">
                                <div class="flex flex-col gap-2">
                                    <template v-for="raion in raions">
                                        <NuxtLink :to="`/${offertype}/${type}/${raion.slug}-raion`" class="text-sm w-fit hover:text-brand-blue hover:underline" >
                                            {{ raion.header }}
                                        </NuxtLink>
                                    </template>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </section>
        </template>
    </LayoutsCatalog>
</template>